import { API_BASE_URL } from "utils/constants";

const SystemConfigPaths = {
  get_system_config: `${API_BASE_URL}/chat/config`,

  update_system_config: `${API_BASE_URL}/chat/config`,

  get_system_mlog_config: `${API_BASE_URL}/chat/mlog-llm-config`,

  update_system_mlog_config: `${API_BASE_URL}/chat/mlog-llm-config`,
};

export default SystemConfigPaths;
